/**
 * Gruppkraft — omdömessektion
 *
 * - Räknar upp betyget (t.ex. 0,0 → 4,9) och antalet omdömen när
 *   sammanfattningskortet scrollas in i vyn; stjärnorna tänds i sekvens
 *   och korten tonas in stegvis (styrs av CSS-klassen is-inview).
 * - Pilknappar scrollar karusellen ett kort i taget.
 * - HTML:en innehåller slutvärdena från början, så utan JavaScript eller
 *   med prefers-reduced-motion visas det färdiga resultatet direkt.
 * Vanilla JS, inga beroenden.
 */
(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function formatNumber(value, decimals) {
    return value.toLocaleString("sv-SE", {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals,
    });
  }

  function animateCount(el) {
    var target = parseFloat(el.dataset.countTo);
    var decimals = parseInt(el.dataset.decimals || "0", 10);
    var suffix = el.dataset.suffix || "";
    if (isNaN(target)) return;

    var duration = 1600;
    var startTime = null;

    function frame(now) {
      if (startTime === null) startTime = now;
      var t = Math.min(1, (now - startTime) / duration);
      // ease-out cubic — snabb start, mjuk inbromsning mot slutvärdet
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatNumber(target * eased, decimals) + suffix;
      if (t < 1) {
        requestAnimationFrame(frame);
      } else {
        el.textContent = formatNumber(target, decimals) + suffix;
      }
    }

    requestAnimationFrame(frame);
  }

  function initSection(root) {
    if (root.dataset.reviewsInit === "1") return;
    root.dataset.reviewsInit = "1";

    /* Karusellpilar */
    var track = root.querySelector("[data-reviews-track]");
    if (track) {
      root.querySelectorAll("[data-reviews-prev], [data-reviews-next]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var card = track.querySelector(".review-card");
          var step = card ? card.offsetWidth + 24 : 360;
          var dir = btn.hasAttribute("data-reviews-prev") ? -1 : 1;
          track.scrollBy({
            left: dir * step,
            behavior: REDUCED ? "auto" : "smooth",
          });
        });
      });
    }

    /* Uppräkning + reveal när sektionen syns */
    var counts = Array.prototype.slice.call(
      root.querySelectorAll("[data-count-to]")
    );

    if (REDUCED || !("IntersectionObserver" in window)) {
      root.classList.add("is-inview");
      return; // slutvärdena står redan i HTML:en
    }

    // Aktiverar de dolda startlägena i CSS — sätts bara när JS faktiskt kör,
    // så att innehållet alltid syns om skriptet blockeras.
    root.classList.add("reviews--js");

    // Nollställ siffrorna tills sektionen syns (HTML:en har slutvärdena)
    counts.forEach(function (el) {
      var decimals = parseInt(el.dataset.decimals || "0", 10);
      el.textContent = formatNumber(0, decimals) + (el.dataset.suffix || "");
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          root.classList.add("is-inview");
          counts.forEach(animateCount);
          observer.disconnect();
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(root.querySelector("[data-reviews-summary]") || root);
  }

  function initAll() {
    document.querySelectorAll("[data-reviews]").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var el = event.target.querySelector("[data-reviews]");
    if (el) {
      delete el.dataset.reviewsInit;
      initSection(el);
    }
  });
})();
